import React, { useState } from 'react'
import { BsFillBagFill } from 'react-icons/bs'
import { useGlobalContext } from '../context'

import { Link } from 'react-router-dom'


function Products() {
    const { products, addToBag } = useGlobalContext()
    return (
        <section className='products' id='products'>
            <div className="container">
                <h1 className='section-title'>Products</h1>
                <div className="products-wrapper">

                    {
                        products.map((product) => {
                            const { id, image, name, price, sizes, inStock } = product;
                            return (
                                <div className="product" key={id}>
                                    <img src={image[0]} alt="" className='product-img' />

                                    <Link to={`/product/${id}`} className="product-name">
                                        {name}
                                    </Link>
                                    <ul className="sizes">
                                        sizes:
                                        {
                                            sizes.map((size, index) =>
                                                <li
                                                    className={`size`}
                                                    key={index}
                                                >{size}
                                                </li>
                                            )
                                        }
                                    </ul>
                                    <div className="product-price">{price} <span>LE</span></div>
                                    <button className="add-to-bag" onClick={() => addToBag(id)}>add to bag</button>
                                </div>
                            )

                        })
                    }



                </div>
            </div>
        </section>
    )
}

export default Products